import React, { FC } from 'react';
import { joinStrings } from '../../../utils/string';
import { Game, GameItemResponse } from '../../Games/games.model';
import { transformGameData } from '../../../utils/games/games.utils';
import { useGameDetailsUrl } from '../../../hooks/games';
import { DynamicImage } from '../../shared/DynamicImage';
import './ItvTopCarouselSlide.scss';

export type ItvTopCarouselSlideProps = {
  game: GameItemResponse;
  index: number;
};

export const ItvTopCarouselSlide: FC<ItvTopCarouselSlideProps> = ({ game, index }) => {
  const gameData = transformGameData(game) as Game;

  const { gameImageTall, friendlyUrlName, brand, gameType, displayName } = gameData;

  const { buildGameDetailsUrl } = useGameDetailsUrl(brand, gameType);
  const realLaunchUrl = buildGameDetailsUrl(friendlyUrlName, 'real');

  return (
    <a href={realLaunchUrl} className="itv-top-carousel-slide">
      <div className="itv-top-carousel-slide__number">{index}</div>

      {/* Legacy usage for skeleton loaders is kept */}
      {displayName === 'skeleton-tile' ? (
        <div
          className={joinStrings([
            'itv-top-carousel-slide__image',
            'itv-top-carousel-slide__image--skeleton',
            'itv-top-carousel-slide__image--skeleton--animated',
          ])}
        />
      ) : (
        <DynamicImage
          src={gameImageTall.imgUrl}
          props={{
            alt: 'game image',
          }}
          className="itv-top-carousel-slide__image"
        />
      )}
    </a>
  );
};
